import { render, staticRenderFns } from "./AttivaNuovoUtente.vue?vue&type=template&id=379d7d0e&"
import script from "./AttivaNuovoUtente.vue?vue&type=script&lang=js&"
export * from "./AttivaNuovoUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports